module.exports = __webpack_public_path__ + "assets/images/1582d811f8a98da45982815e990104a1.png";